import React, { createContext, useContext, useState } from 'react';

const SuccessContext = createContext();

export const useSuccess = () => {
  return useContext(SuccessContext);
};

export const SuccessProvider = ({ children }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const displaySuccess = (message) => {
    setSuccessMessage(message);
    setShowSuccess(true);
    
    // Auto hide after 5 seconds
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const clearSuccess = () => {
    setShowSuccess(false);
    setSuccessMessage('');
  };

  const value = {
    showSuccess,
    successMessage,
    displaySuccess,
    clearSuccess
  };

  return (
    <SuccessContext.Provider value={value}>
      {children}
    </SuccessContext.Provider>
  );
};